import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Prompt } from 'react-router-dom';
import { Row, Col, Button, Clearfix } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { omit as _omit, get as _get } from 'lodash';

import { changeUploadContext, resetUploadContext, fileUploadHelper } from 'actions/UploadActions';
import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { blockForm, releaseForm } from 'actions/ActiveFormsActions';
import { addNotification } from 'actions/NotificationsActions';
import { getThumbFileFromEntity } from 'helpers/items';
import { formatEntityErrorsForDisplay } from 'helpers/formStatus';

import EntityStateUpdater from 'component/EntityStateUpdater';

import RoundImage from 'components/layout/RoundImage';
import Breadcrumb from 'components/layout/Breadcrumb';
import Tabs from 'components/layout/Tabs';
import FabActions from 'components/layout/FabActions';
import FabActionElement from 'components/layout/FabActionElement';
import IntlDate from 'components/layout/IntlDate';

import Timeline from 'components/layout/client/Timeline';
import ClientProfile from 'components/layout/client/ClientProfile';
import ClientDocs from 'components/layout/client/ClientDocs';
import ClientFinancial from 'components/layout/client/ClientFinancial';
import ClientVendor from 'components/layout/client/ClientVendor';
import ClientLocations from 'components/layout/client/ClientLocations';
import ClientHolding from 'components/layout/client/ClientHolding';
import ClientActions from 'components/layout/client/ClientActions';
import ClientConditions from 'components/layout/client/ClientConditions';
import ClientProductGroupDiscounts from 'components/layout/client/ClientProductGroupDiscounts';

import MessageNew from 'components/modals/MessageNew';
import Quotes from 'components/modals/Quotes';
import Invoices from 'components/modals/Invoices';
import Leads from 'components/modals/Leads';
import Orders from 'components/modals/Orders';
import Users from 'components/modals/Users';
import Templates from 'components/modals/Templates';

import Entity from 'components/Entity';
import Count from 'components/Count';
import Data from 'components/Data';

import { entityMetaMapping, ROLE_ADMIN, ROLE_ROOT_EMPLOYEE, ROLE_WL_ADMIN } from 'js/constants';
import may from 'js/security';

import ActiveFormsToolbar from 'components/forms/ActiveFormsToolbar';
import FormErrors from 'components/forms/FormErrors';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';
import ClientNew from 'components/modals/ClientNew';
import UserNew from 'components/modals/UserNew';
import FormSwitchery from 'components/forms/FormSwitchery';
import ProductTemplateCSS from '../productTemplate/ProductTemplateCSS';
import ClientCorporateDesign from './ClientCorporateDesign';
import ClientContactManagement from './ClientContactManagement';
import CompanyDataForm from "components/forms/clients/CompanyDataForm";
import CompanyDataTimeline from "components/layout/client/CompanyDataTimeline";
import Axios from 'axios';

class ClientView extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      showMessageNew: false,
      showInvoices: false,
      showQuotes: false,
      showLeads: false,
      showOrders: false,
      showUsers: false,
      showTemplates: false,
      entityLoaded: false,
      entityChanged: false,
      activeFormsInitiated: false,
      isVendor: false,
      uploading: false,
      showNew: false,
      showNewCompany: false,
      sendInvitation: false,
    };

    this.entity = new Entity();

    if (props.meta[entityMetaMapping.client] !== undefined && !props.meta[entityMetaMapping.client].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.client);
    }

    if (this.entity.getDataLoaded() && this.entity.getMetaLoaded()) {
      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }

    this.dataRef = React.createRef();
  }

  showMessageNew = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ showMessageNew: true });
  };

  closeMessageNew = () => {
    this.setState({ showMessageNew: false });
  };

  showQuotes = () => {
    this.setState({ showQuotes: true });
  };

  closeQuotes = () => {
    this.setState({ showQuotes: false });
  };

  showInvoices = () => {
    this.setState({ showInvoices: true });
  };

  closeInvoices = () => {
    this.setState({ showInvoices: false });
  };

  showLeads = () => {
    this.setState({ showLeads: true });
  };

  closeLeads = () => {
    this.setState({ showLeads: false });
  };

  showOrders = () => {
    this.setState({ showOrders: true });
  };

  closeOrders = () => {
    this.setState({ showOrders: false });
  };

  showUsers = () => {
    this.setState({ showUsers: true });
  };

  closeUsers = () => {
    this.setState({ showUsers: false });
  };

  showTemplates = () => {
    this.setState({ showTemplates: true });
  };

  closeTemplates = () => {
    this.setState({ showTemplates: false });
  };

  uploadClientAssets = files => {
    this.manualUpload(files);
  };

  showNew = () => {
    this.setState({ showNew: true });
  };

  closeNew = () => {
    this.setState({ showNew: false });
  };

  showNewCompany = () => {
    this.setState({ showNewCompany: true });
  };

  closeNewCompany = () => {
    this.setState({ showNewCompany: false });
  };

  componentWillMount = () => {
    const { clientId } = this.props;

    this.props.updateUploadContext({
      type: 'client_img',
      clientId,
      uploadLink: `/api/avatars/${clientId}.json`,
    });
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      clientId,
      meta,
      formStatus,
      activeForms,
      data,
      doNotify,
      doBlockForm,
    } = this.props;
    const { entity, entityLoaded, activeFormsInitiated } = this.state;

    if (!prevProps.activeForms.allowEdit && activeForms.allowEdit) {
      if (this.dataRef && this.dataRef.current) {
        this.dataRef.current.fetch();
      }
      this.setState({ entityLoaded: false });
    }

    // client data was saved and there was no error
    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      this.setState({ entityChanged: false });
      doNotify(1, messages.client_data_saved);
    }

    // a new company is loaded: close the new company popup
    const { clientId: prevClientId } = prevProps;
    if (clientId !== prevClientId) {
      this.closeNewCompany();
    }

    if (prevProps.data.pending && !data.pending) {
      this.entity.setData(data.data);
      if (this.entity.getMetaLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }

      // we received the client data
      // now we have to see if we can block the page edit to ourselves
      if (!activeFormsInitiated && !may('ROLE_ROOT_EMPLOYEE', this.props.user.roles)) {
        this.setState({ activeFormsInitiated: true }, () => doBlockForm(clientId));
      }
    }

    if (
      meta[entityMetaMapping.client] !== undefined &&
      !meta[entityMetaMapping.client].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.client);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }

    if (entityLoaded && prevProps.data.data.locations && data.data.locations) {
      // image has been uploaded, update the item imgage list
      for (let i = 0; i < data.data.locations.length; i++) {
        if (
          data.data.locations[i].imgs &&
          entity.getLocations()[i] &&
          data.data.locations[i].imgs.length !== entity.getLocations()[i].getImgs().length
        ) {
          // we found the location where count of images has changed
          const imgs = [];
          for (let j = 0; j < data.data.locations[i].imgs.length; j++) {
            imgs.push(
              this.state.entity.createValue('imgs', ['locations', i.toString()], data.data.locations[i].imgs[j])
            );
          }
          this.updateEntity('imgs', imgs, ['locations', i.toString()]);

          // end the loop
          break;
        }
      }
    }

    if (entityLoaded && !prevProps.data.pending && !data.pending) {
      const avatarId = !!_get(data, 'data.profile.avatar.variations') && _get(data, 'data.profile.avatar.id');
      const prevAvatarId = _get(prevProps, 'data.data.profile.avatar.id');

      if (avatarId && avatarId !== prevAvatarId) {
        // we have a new avatar
        // update the entity (quiet)
        const value = this.state.entity.createValue('avatar', ['profile'], data.data.profile.avatar);
        this.updateEntity('avatar', value, ['profile'], null, false);

        this.props.doNotify(1, messages.file_uploaded);
      }
    }
  };

  componentWillUnmount = () => {
    const { clientId, doResetUploadContext, doReleaseForm } = this.props;
    // release the block so that other users may work on the client data
    doReleaseForm(clientId);
    doResetUploadContext();
  };

  formSubmit = e => {
    e.preventDefault();

    const { clientId, activeForms, onSubmit } = this.props;
    const { entity, sendInvitation } = this.state;

    if (activeForms.allowEdit) {
      this.setState(
        prevState => ({ entity: prevState.entity.validate() }),
        () => {
          if (this.state.entity.isValid) {
            // ommit unnecessary data
            const data = _omit(this.state.entity.processedData, ['projectLang', 'type']);
            onSubmit(clientId, { ...data, sendInvitation: !!(entity.getProfile().getEmail() && sendInvitation) });

          }
        }
      );
    }
  };

  getTabHeaderList = () => {
    const {
      intl: { messages },
      editClient,
      // editUser,
      user,
    } = this.props;
    const { entity, entityLoaded, isVendor } = this.state;
    const result = [];

    if (entityLoaded && !isVendor && entity?.data?.roles?.includes?.('ROLE_VENDOR')) {
      this.setState({ isVendor: true });
    }

    if (editClient) {
      result.push(messages.infos);
    }
    result.push(messages.profile);

    result.push(messages.documents);

    result.push(messages.financial);
    if (isVendor) {
      result.push(messages.vendor);
    }
    if (editClient) {
      result.push(messages.locations);
    }

    /*
    if ((editClient || editUser) && may('ROLE_CRM_ROLES', user.roles)) {
      result.push(messages.roles);
    }

    if (editClient && may('ROLE_CRM_WHITE_LABEL', user.roles)) {
      result.push(messages.white_label);
    }

    if (may(ROLE_SUPERADMIN, user.roles)) {
      result.push(messages.external_accounts);
    }
    */

    if (may(ROLE_ROOT_EMPLOYEE, user.roles)) {
      result.push(messages.individual_prices);
      result.push(messages.discounts.discounts_tab_title);
      result.push(messages.template_styles);
      result.push('Corporate Design');
    }

    if (
      (entityLoaded && entity.data.in_holding && may('ROLE_ADMIN', user.roles)) ||
      may('ROLE_ROOT_EMPLOYEE', user.roles)
    ) {
      result.push(messages.holding_structure);
    }

    if (entityLoaded && may('ROLE_ADMIN', user.roles)) {
      result.push(messages.contacts);
    }

    result.push(messages.company_data_timeline_tab_title);

    return result;
  };

  getTabContentList = () => {
    const { clientId, editClient, editUser, user, formStatus, activeForms } = this.props;
    const { entity, entityLoaded, isVendor } = this.state;
    const result = [];

    const disabled = formStatus.pending || !activeForms.allowEdit;
    const sharedProps = { entityLoaded, entity, changeEntity: this.changeEntity, disabled };

    if (entityLoaded && !isVendor && entity?.data?.roles?.includes?.('ROLE_VENDOR')) {
      this.setState({ isVendor: true });
    }

    if (editClient) {
      // timeline
      result.push(
        <div key="timeline">
          <Timeline clientId={clientId} timezone={user.profile.timezone} disabled={disabled} />
        </div>
      );
    }
    result.push(<ClientProfile key="profile" typeOfUser={'customer'} entityKey={this.state.key} {...sharedProps} />);
    // documents
    result.push(<ClientDocs key="docs" clientEntityLoaded={entityLoaded} clientEntity={entity} disabled={disabled} />);
    // financial settings (bank account, legal)
    result.push(<ClientFinancial key="financial" isVendor={isVendor} {...sharedProps} />);
    if (isVendor) {
      result.push(<ClientVendor key="vendor" {...sharedProps} />);
    }
    if (editClient) {
      // locations
      result.push(<ClientLocations {...sharedProps} timezone={user.profile.timezone} />);
    }

    /*
    if ((editClient || editUser) && may('ROLE_CRM_ROLES', user.roles)) {
      // security roles
      result.push(<ClientRoles key="roles" {...sharedProps} />);
    }

    // external accounts (ex. mobile.de / PartnerConnect) - only when superadmin

    if (may(ROLE_SUPERADMIN, user.roles)) {
      result.push(<ClientExternalAccounts key="external-accounts" {...sharedProps} />);
    }
    */

    // subscription plan and conditions
    if (may(ROLE_ROOT_EMPLOYEE, user.roles)) {
      result.push(<ClientConditions {...sharedProps} />);
      result.push(<ClientProductGroupDiscounts {...sharedProps} />);
      result.push(<ProductTemplateCSS {...sharedProps} />);
      result.push(
        <ClientCorporateDesign
          {...sharedProps}
          upload={this.uploadClientAssets}
          clientId={clientId}
          uploading={this.props.upload.isUploading}
          updateUploadContext={this.props.updateUploadContext}
        />
      );
    }
    // show tab where the client's holding access will be presented
    if (
      (entityLoaded && entity.data.in_holding && may('ROLE_ADMIN', user.roles)) ||
      may('ROLE_ROOT_EMPLOYEE', user.roles)
    ) {
      // holding settings (parent and ancestors)
      result.push(<ClientHolding key="holding" {...sharedProps} user={user} />);
    }
    if (entityLoaded && may('ROLE_ADMIN', user.roles)) {
      result.push(
        <ClientContactManagement
          clientEntityLoaded={entityLoaded}
          clientEntity={entity}
          disabled={disabled}
          contactReferenceId={entity?.getProfile?.()?.getContactReferenceId()}
          updateDefaultContact={this.updateDefaultContact}
          clientId={clientId}
        />
      );
    }

    result.push(
      <CompanyDataTimeline
        key="companyDataTimeline"
        typeOfUser={'customer'}
        entityKey={this.state.key}
        clientId={clientId}
      />
    );

    return result;
  };

  updateDefaultContact = (contactReferenceId, addressReferenceId, callback) => {
    const { clientId, doNotify } = this.props;
    const { entity } = this.state;
    let url = `/api/clients/${clientId}/contacts/${contactReferenceId}/makedefault.json`;
    Axios.post(url)
      .then(({ data }) => {
        entity.updateValue('contactReferenceId', contactReferenceId, ['profile']);
        entity.updateValue('addressReferenceId', addressReferenceId, ['profile']);
        this.setState({ entity });
      })
      .catch(error => {
        // handle error
        if (Axios.isCancel(error)) {
          console.log('POST request canceled', error);
        } else {
          doNotify(0, 'Error updating default contact');
          console.log(error);
        }
      });
  };

  getTabKeepMounted = () => {
    const { editClient } = this.props;

    const keepMounted = [];
    if (editClient) {
      keepMounted.push(0);
    }
    return keepMounted;
  };

  getBreadcrumb = () => {
    if (this.props.breadcrumb) {
      return this.props.breadcrumb;
    }

    const {
      intl: { messages },
      appIntl,
    } = this.props;
    const { entityLoaded, entity } = this.state;

    let clientHeader;
    if (entityLoaded) {
      if (entity.getProfile().getCompany()) {
        clientHeader = entity.getProfile().getCompany();
      } else {
        clientHeader = entity.getProfile().getFirstName() + ' ' + entity.getProfile().getLastName();
      }
    }

    if (this.props.crumbs) {
      const crumbs = this.props.crumbs.slice();
      crumbs.push({ link: null, name: clientHeader });

      return <Breadcrumb crumbs={crumbs} />;
    }

    return (
      <Breadcrumb
        crumbs={[
          { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
          { link: appIntl.urlPrefix + 'account/clients', name: messages.clients },
          { link: null, name: clientHeader },
        ]}
      />
    );
  };

  getClientDisplayName = () => {
    const { entityLoaded, entity } = this.state;

    let clientHeader;
    if (entityLoaded) {
      if (entity.getProfile().getCompany()) {
        clientHeader = entity.getProfile().getCompany();
      } else {
        clientHeader = entity.getProfile().getFirstName() + ' ' + entity.getProfile().getLastName();
      }
    }
    return clientHeader;
  };

  manualUpload = files => {
    this.setState({ uploading: true }, () => {
      for (let i = 0; i < files.length; i++) {
        const file = files.item(i);
        this.props.uploadFile(file, this.props.upload.context.uploadLink, this.props.upload.context.data);
      }
    });
  };

  render() {
    const {
      intl: { messages },
      clientId,
      formStatus,
      data,
      quotesCount,
      invoicesCount,
      leadsCount,
      usersCount,
      templatesCount,
      ordersCount,
      appIntl,
      user,
    } = this.props;
    const { entityLoaded, entityChanged, entity } = this.state;

    const clientHeader = this.getClientDisplayName();
    let metaTitle = messages.client;
    if (clientHeader) {
      metaTitle += ' -  ' + clientHeader;
    }

    const iconPlusClass = entityLoaded ? 'fa-plus' : 'fa-spinner-third fa-spin';

    return (
      <DocMeta tags={generateMetaTags(messages.meta.client_details, metaTitle)}>
        <div class="padding-25 sm-padding-10" key={clientId}>
          <Data ref={this.dataRef} dataName="client" url={`/api/clients/${clientId}.json`} data={data} />
          <FormErrors formStatus={formStatus} additionalErrors={formatEntityErrorsForDisplay(entity, messages)} />

          <Prompt
            when={entityChanged}
            message={location => messages.save_data_before_nav_to_pathname.replace('{pathname}', location.pathname)}
          />

          <form method="put" onSubmit={this.formSubmit}>
            <Count
              countName="clientInvoices"
              url="/api/invoices/count.json"
              urlData={{ filters: { target: clientId } }}
            />
            <Count countName="clientQuotes" url="/api/quotes/count.json" urlData={{ filters: { target: clientId } }} />
            <Count countName="clientOrders" url="/api/orders/count.json" urlData={{ filters: { target: clientId } }} />
            <Count countName="clientUsers" url="/api/users/count.json" urlData={{ filters: { parent: clientId } }} />
            <Count
              countName="clientTemplates"
              url="/api/producttemplates/count.json"
              urlData={{ filters: { target: clientId } }}
            />
            <Count
              countName="leads"
              url="/api/leads/count.json"
              urlData={{ filters: { target: clientId }, showClosed: true }}
            />

            {this.getBreadcrumb()}

            {this.props.editClient && (
              <section class="panel no-padding">
                <div class="client-profile-header">
                  <Row>
                    <Col xs={6} md={4}>
                      <div class="text-center p-t-10 p-b-10 pull-left" style={{ width: '260px' }}>
                        {entityLoaded && getThumbFileFromEntity(entity.getProfile().getAvatar()) ? (
                          <RoundImage
                            class="uploadProfileIcon"
                            size={75}
                            url={getThumbFileFromEntity(entity.getProfile().getAvatar()).getWebLink()}
                          >
                            <div className="pull--40 uploadProfileIconIn">
                              <input
                                type="file"
                                ref={ref => {
                                  this.uploadInput = ref;
                                }}
                                style={{ display: 'none' }}
                                onChange={e => this.manualUpload(e.target.files)}
                              />
                              <Button bsSize="sm" class="btn-rounded" onClick={() => this.uploadInput.click()}>
                                <i className="fa fa-upload m-r-10" /> {messages.upload}
                              </Button>
                            </div>
                          </RoundImage>
                        ) : (
                          <RoundImage size={75}>
                            <div class="relative">
                              <i class="far fa-user-circle hint-text" style={{ fontSize: '170px' }} />

                              {entityLoaded && (
                                <div class="pull--40">
                                  <input
                                    type="file"
                                    ref={ref => {
                                      this.uploadInput = ref;
                                    }}
                                    style={{ display: 'none' }}
                                    onChange={e => this.manualUpload(e.target.files)}
                                  />
                                  <Button bsSize="sm" class="btn-rounded" onClick={() => this.uploadInput.click()}>
                                    <i class="fa fa-upload m-r-10" /> {messages.upload}
                                  </Button>
                                </div>
                              )}
                            </div>
                          </RoundImage>
                        )}
                      </div>
                      <div class="pull-left">
                        <h5 class="m-t-40 text-uppercase">
                          <span>{messages.client_since}</span> {entityLoaded && <IntlDate date={entity.getCdate()} />}
                        </h5>
                        <h3 class="m-t-20">{clientHeader}</h3>
                        <h5 class="m-t-20 text-uppercase">{entityLoaded && entity.getProfile().getCity()}</h5>
                        <div>
                          <a
                            href={`/api/clients/${clientId}/export.json`}
                            class="btn"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Export
                          </a>
                        </div>
                      </div>
                      <Clearfix />
                    </Col>
                    <Col xs={6} md={8}>
                      <Row style={{ borderLeft: '1px solid #ccc' }}>
                        <Col xs={12}>
                          <div class="p-t-25 p-b-25 p-l-20">
                            <div class="pull-left">
                              <i class="fal fa-map-marker-alt fa-3x fa-fw" />
                            </div>
                            {entityLoaded && (
                              <div class="pull-left m-l-15">
                                {entity.getProfile().getStreet()} {entity.getProfile().getHouseNumber()}{' '}
                                {entity.getProfile().getApartmentNumber()}
                                <br />
                                {entity.getProfile().getZipCode()} {entity.getProfile().getCity()}
                              </div>
                            )}
                            <Clearfix />
                          </div>
                        </Col>
                        <Col xs={12}>
                          <div class="p-t-25 p-b-25 p-l-20">
                            <div class="pull-left">
                              <i class="fal fa-phone fa-3x fa-fw" />
                            </div>
                            {entityLoaded && (
                              <div class="pull-left m-l-15" style={{ paddingTop: '12px' }}>
                                {entity.getProfile().getPhone() ? (
                                  <a href={'tel:' + entity.getProfile().getPhone()} class="text-master">
                                    {entity.getProfile().getPhone()}
                                  </a>
                                ) : (
                                  '-'
                                )}
                              </div>
                            )}
                            <Clearfix />
                          </div>
                        </Col>
                        <Col xs={12}>
                          <div class="p-t-25 p-b-25 p-l-20">
                            <div class="pull-left">
                              <i class="fal fa-at fa-3x fa-fw" />
                            </div>
                            {entityLoaded && (
                              <div class="pull-left m-l-15" style={{ paddingTop: '12px' }}>
                                {entity.getProfile().getEmail() ? (
                                  <a href="#newMessage" class="text-master" onClick={this.showMessageNew}>
                                    {entity.getProfile().getEmail()}
                                  </a>
                                ) : (
                                  '-'
                                )}
                              </div>
                            )}
                            <Clearfix />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>

                <Row className="client-activities">
                  <Col sm={12}>
                    <Row>
                      <Col xs={2}>
                        <div class="text-left cursor" onClick={this.showOrders}>
                          <h5 class="p-t-20 p-b-20 text-uppercase">
                            {messages.orders}
                            {': '}
                            <b>{!ordersCount.pending && ordersCount.data}</b>
                            <span class="hidden-md hidden-lg">({!ordersCount.pending && ordersCount.data})</span>
                          </h5>
                        </div>
                      </Col>
                      {may(ROLE_ROOT_EMPLOYEE, user.roles) && (
                        <Col xs={2}>
                          <div class="text-left cursor" onClick={this.showQuotes}>
                            <h5 class="p-t-20 p-b-20 text-uppercase">
                              {messages.salesDoc.quotes}
                              {': '}
                              <b>{!quotesCount.pending && quotesCount.data}</b>
                              <span class="hidden-md hidden-lg">({!quotesCount.pending && quotesCount.data})</span>
                            </h5>
                          </div>
                        </Col>
                      )}
                      <Col xs={2}>
                        <div class="text-left cursor" onClick={this.showInvoices}>
                          <h5 class="p-t-20 p-b-20 text-uppercase">
                            {messages.salesDoc.invoices}
                            {': '}
                            <b>{!invoicesCount.pending && invoicesCount.data}</b>
                            <span class="hidden-md hidden-lg">({!invoicesCount.pending && invoicesCount.data})</span>
                          </h5>
                        </div>
                      </Col>
                      {may(ROLE_ROOT_EMPLOYEE, user.roles) && (
                        <Col xs={2}>
                          <div class="text-left cursor" onClick={this.showLeads}>
                            <h5 class="p-t-20 p-b-20 text-uppercase">
                              {messages.leads}
                              {': '}
                              <b>{!leadsCount.pending && leadsCount.data}</b>
                              <span class="hidden-md hidden-lg">({!leadsCount.pending && leadsCount.data})</span>
                            </h5>
                          </div>
                        </Col>
                      )}
                      <Col xs={2}>
                        <div class="text-left cursor" onClick={this.showUsers}>
                          <h5 class="p-t-20 p-b-20 text-uppercase">
                            {messages.user}
                            {': '}
                            <b>{!usersCount.pending && usersCount.data}</b>
                            <span class="hidden-md hidden-lg">({!usersCount.pending && usersCount.data})</span>
                          </h5>
                        </div>
                      </Col>
                      {may(ROLE_ROOT_EMPLOYEE, user.roles) && (
                        <Col xs={2}>
                          <div class="text-left cursor" onClick={this.showTemplates}>
                            <h5 class="p-t-20 p-b-20 text-uppercase">
                              {messages.producttemplates}
                              {': '}
                              <b>{!templatesCount.pending && templatesCount.data}</b>
                              <span class="hidden-md hidden-lg">
                                ({!templatesCount.pending && templatesCount.data})
                              </span>
                            </h5>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </section>
            )}

            <Row>
              <Col xs={6}>
                <div>
                  <Button
                    onClick={this.showNew}
                    bsStyle="primary"
                    className="btn-rounded m-r-10"
                    title={messages.add_user}
                    disabled={!entityLoaded}
                  >
                    <i className={'fal m-r-10 sm-m-r-0 ' + iconPlusClass} />{' '}
                    <span className="hidden-xs">{messages.add_user}</span>
                  </Button>{' '}
                  <UserNew show={this.state.showNew} close={this.closeNew} clientData={entityLoaded && entity.data} />
                  <Button
                    onClick={this.showNewCompany}
                    bsStyle="primary"
                    className="btn-rounded"
                    title={messages.add_client}
                    disabled={!entityLoaded}
                  >
                    <i className={'fal m-r-10 sm-m-r-0 ' + iconPlusClass} />{' '}
                    <span className="hidden-xs">{messages.add_client}</span>
                  </Button>
                  <ClientNew show={this.state.showNewCompany} close={this.closeNewCompany} parent={entity} />
                  <CompanyDataForm entity={entity} entityLoaded={entityLoaded} changeEntity={this.changeEntity}/>
                </div>
              </Col>
              <Col xs={6}>
                <ActiveFormsToolbar
                  formStatus={formStatus}
                  entityChanged={entityChanged}
                  formType="client"
                  formId={clientId}
                  fabActions={
                    entityLoaded ? (
                      <FabActions>
                        <ClientActions
                          client={data.data}
                          wrapperComponent={null}
                          listItemComponent={<FabActionElement size="60" />}
                        />
                      </FabActions>
                    ) : null
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Tabs
                  tabs={this.getTabHeaderList()}
                  tabContent={this.getTabContentList()}
                  keepMounted={this.getTabKeepMounted()}
                />
              </Col>
            </Row>
            {(may(ROLE_WL_ADMIN, user.roles) || may(ROLE_ADMIN, user.roles)) && entityLoaded && (
              <Row>
                <Col xs={12}>
                  <div className="form-group form-group-default">
                    <FormSwitchery
                      name="sendInvite"
                      label={
                        messages.send_invitation_with_username_and_password +
                        ' (' +
                        (entity.getProfile().getEmail() || '-') +
                        ')'
                      }
                      value
                      checked={!!(this.state.sendInvitation && entity.getProfile().getEmail())}
                      onChange={(name, value) => this.setState({ sendInvitation: value })}
                      disabled={!!(formStatus.pending || !entity.getProfile().getEmail())}
                    />
                  </div>
                </Col>
              </Row>
            )}
          </form>
          <Orders
            show={this.state.showOrders}
            close={this.closeOrders}
            urlData={{ filters: { target: clientId }, showClosed: true }}
          />
          <MessageNew show={this.state.showMessageNew} close={this.closeMessageNew} client={entity} />
          <Invoices
            show={this.state.showInvoices}
            close={this.closeInvoices}
            urlData={{ filters: { target: clientId } }}
          />
          {may(ROLE_ROOT_EMPLOYEE, user.roles) && (
            <>
              <Quotes
                show={this.state.showQuotes}
                close={this.closeQuotes}
                urlData={{ filters: { target: clientId } }}
              />
              <Leads
                show={this.state.showLeads}
                close={this.closeLeads}
                urlData={{ filters: { target: clientId }, showClosed: true }}
              />
            </>
          )}
          <Users
            show={this.state.showUsers}
            close={this.closeUsers}
            urlData={{ filters: { parent: clientId, type: 'employee' }, showClosed: true }}
            appIntl={appIntl}
          />
          {may(ROLE_ROOT_EMPLOYEE, user.roles) && (
            <Templates
              show={this.state.showTemplates}
              close={this.closeTemplates}
              urlData={{ filters: { target: clientId }, showClosed: true }}
              appIntl={appIntl}
            />
          )}
        </div>
      </DocMeta>
    );
  }
}
ClientView.defaultProps = {
  editUser: false,
  editSelf: false,
  editClient: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    data: state.data.client,
    meta: state.entityMeta,
    invoicesCount: state.count.clientInvoices,
    quotesCount: state.count.clientQuotes,
    leadsCount: state.count.leads,
    ordersCount: state.count.clientOrders,
    usersCount: state.count.clientUsers,
    templatesCount: state.count.clientTemplates,
    user: state.login.user,
    formStatus: state.formStatus.clientEdit,
    activeForms: state.activeForms,
    upload: state.upload,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateUploadContext: newContext => {
      dispatch(changeUploadContext(newContext));
    },
    doResetUploadContext: () => {
      dispatch(resetUploadContext());
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    onSubmit: (clientId, args) => {
      formStatusDispatchHelper('clientEdit', `/api/clients/${clientId}.json`, args, 'put', dispatch);
    },
    uploadFile: fileUploadHelper(dispatch),
    doBlockForm: id => {
      dispatch(blockForm('client', id));
    },
    doReleaseForm: id => {
      dispatch(releaseForm('client', id));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ClientView)
  )
);
